import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
export function LimitedSpots() {
  const totalSpots = 100;
  const soldSpots = 87;
  const remainingSpots = totalSpots - soldSpots;
  const percentage = soldSpots / totalSpots * 100;
  return <div className="bg-white rounded-2xl p-6 shadow-medium border border-cta-primary/20" data-id="element-439">
      <div className="flex items-start gap-3 mb-4" data-id="element-440">
        <div className="flex-shrink-0 w-10 h-10 bg-cta-primary/10 rounded-xl flex items-center justify-center" data-id="element-441">
          <AlertCircleIcon className="w-5 h-5 text-cta-primary" data-id="element-442" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-443">
          <p className="font-bold text-deep-cocoa text-lg mb-1" data-id="element-444">
            Solo quedan {remainingSpots} lugares
          </p>
          <p className="text-sm text-deep-cocoa/60" data-id="element-445">
            {soldSpots} de {totalSpots} personas compraron hoy
          </p>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="relative w-full h-3 bg-almond-milk rounded-full overflow-hidden" data-id="element-446">
        <div className="absolute inset-y-0 left-0 bg-gradient-to-r from-cta-primary to-cta-secondary rounded-full transition-all duration-500 ease-out" style={{
        width: `${percentage}%`
      }} data-id="element-447">
          <div className="absolute inset-0 bg-white/20 animate-pulse-soft" data-id="element-448"></div>
        </div>
      </div>
    </div>;
}